<template>
  <div>
    <el-form-item label="Typ pola">
      <el-select
        v-model="form.field_type"
        filterable
        clearable
        placeholder="Wybierz pole"
      >
        <el-option
          v-for="item in charFieldTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['form', 'errors'],
  data() {
    return {
      charFieldTypes: [
        { label: 'Tekst', value: 'StandardCharField' },
        { label: 'Tylko litery', value: 'AlphabeticField' },
        { label: 'Data', value: 'DateField' },
        { label: 'Data i czas', value: 'DateTimeField' },
        { label: 'Email', value: 'EmailField' },
        { label: 'Link', value: 'URLField' },
        { label: 'Liczba', value: 'NumberField' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
